<mat-form-field class="example-full-width"  [formGroup]="dateForm">
    <mat-label>{{label}}</mat-label>
    <input matInput [matDatepicker]="picker" placeholder={{placeholder}} formControlName="date">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>